import script from "./ArtifactContentDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArtifactContentDisplay.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QSplitter from 'quasar/src/components/splitter/QSplitter.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSplitter});
